module.exports = __webpack_public_path__ + "f96ffbf618fefdf8687959bb5ea76e8f.pdf";